<ng-container [ngSwitch]="action?.type">
  <txtb-zoom
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.Zoom"
  ></txtb-zoom>
  <txtb-gallery
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.Gallery"
  ></txtb-gallery>
  <txtb-hyperlink
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.Hyperlink"
  ></txtb-hyperlink>
<!--  <txtb-trigger-->
<!--    [groupInfo]="$any(groupInfo)"-->
<!--    [action]="$any(action)"-->
<!--    *ngSwitchCase="actionType.Trigger"-->
<!--  ></txtb-trigger>-->
<!--  <txtb-alias-->
<!--    [groupInfo]="$any(groupInfo)"-->
<!--    [action]="$any(action)"-->
<!--    *ngSwitchCase="actionType.Alias"-->
<!--  ></txtb-alias>-->
  <txtb-audio
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.Audio"
  ></txtb-audio>
  <txtb-link
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.Link"
  ></txtb-link>
  <txtb-video
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.Video"
  ></txtb-video>
  <txtb-document
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.Document"
  ></txtb-document>
  <txtb-document-inline
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.DocumentInline"
  ></txtb-document-inline>
  <txtb-teacher-comment
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.TeacherComment"
  ></txtb-teacher-comment>
  <txtb-interaction
  #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.Interaction"
  ></txtb-interaction>
  <txtb-selfcheck-exercise
    #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.SelfcheckExercise"
  ></txtb-selfcheck-exercise>
  <txtb-exercise
    #actionHandlerComponent
    [groupInfo]="$any(groupInfo)"
    [action]="$any(action)"
    *ngSwitchCase="actionType.Exercise"
  ></txtb-exercise>
  <txtb-not-found *ngSwitchDefault></txtb-not-found>
</ng-container>
